import { Functionality } from 'api/userPermissions/userPermissions.enum';
import { PermissionRow } from '../permissionRow/PermissionRow';
import { PermissionOptions } from '../permissionRow/PermissionRow.types';
import { SectionHeader } from '../sectionHeader/SectionHeader';

import { SectionHeaderProps } from './PermissionHeader.types';

export const PermissionHeader = ({ title, functionality, disabled = false }: SectionHeaderProps) => {
  const isFullOption = (func: Functionality) => {
    const fullOptions: Functionality[] = [
      Functionality.HARMONOGRAMY,
      Functionality.KARTY_POSIADACZE,
      Functionality.URZADZENIA_GLC,
      Functionality.SEKWENCJA,
      Functionality.POSZUKIWANY,
      Functionality.KONTROLA,
      Functionality.ZDARZENIA,
      Functionality.UPR_INDYWIDUALNE,
    ];
    return fullOptions.includes(func);
  };

  return (
    <SectionHeader
      title={title}
      renderPermissionRow={() => (
        <PermissionRow
          functionality={functionality}
          title=""
          options={isFullOption(functionality) ? PermissionOptions.FULL : PermissionOptions.EDIT_ONLY}
          disabled={disabled}
        />
      )}
    />
  );
};
